import { render, staticRenderFns } from "./OpenBallot.vue?vue&type=template&id=679abbe7&"
import script from "./OpenBallot.vue?vue&type=script&lang=js&"
export * from "./OpenBallot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports